class localhostSettings { }

const win: any = window;
if (window.location.href.includes("localhost")) {  //localhost
  win["lang"] = "en";
  // win["lang"] = "ar";
  // document.documentElement.dir = "rtl";
  win["isLoggedIn"] = 'false';
  document.documentElement.lang = win["lang"];
  // !!!win["base_portal_url"] && (win["base_portal_url"] = "http://sdea004:8080");
  !!!win["base_portal_url"] && (win["base_portal_url"] = "http://ssta004:8080");
  !!!win["bmToken"] && (win["bmToken"] = import.meta.env.VITE_CLIENT_TKN);
  !!!win["store_order_track"] && (win["store_order_track"] = "/wps/portal/web/personal/store/order");
  !!!win["home_page_url"] && (win["home_page_url"] = "/wps/wcm/connect/en/personal");
  !!!win["errorPageURL"] && (win["errorPageURL"] = "/wps/portal/web/personal/store/error");
  !!!win["apigee_base_api_url"] && (win["apigee_base_api_url"] = "https://apisit.mobily.com.sa/api");
  !!!win["apigee_bm_base_url"] && (win["apigee_bm_base_url"] = "https://apisit.mobily.com.sa");
  win["environment_value"] = "DEV";
  win["cem_key"] = import.meta.env.VITE_CEM_K;
  win["bm_rsa_public_key"] = import.meta.env.VITE_BM_PUBLIC_KEY;
  win["apigee_bm_x_api_key"] = import.meta.env.VITE_APIGEE_BM_X_APIK;
  win["storeGoogleMapKey"] = import.meta.env.VITE_GOOGLE_MAP_KEY;
  win["cem_public_key"] = import.meta.env.VITE_CEM_PUBLIC_KEY;
} 

export default localhostSettings;
